import Alert from 'react-bootstrap/Alert';

export default function MessageBox(props) {
  return (
    <Alert className={props.className || 'default-alert'}>
      <div className="text-center">{props.children}</div>
    </Alert>
    // Alert is a component from react-bootstrap and is used to display a contextual message to the user
    // if there is no variant prop being passed through, 'info' will be the default
    // renders the content of the children from Alert (for exaple the {error} in the HomeScreen component)
  );
}
